import React, { Component } from 'react';
import { soundManager } from 'soundmanager2';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css'
import preRoll from './preroll/ksyz-preroll.mp3';
const mp3_stream = 'https://stream.customchannels.net/holiday_ksyz_96.mp3';

class PlayerControls extends Component {

    constructor(props){
        super(props);
        this.state = {
          playing: false,
          volume: 50,
          preRollPlay: false
        };
    }

    createPreroll(){
      const self = this;
      this.preroll = soundManager.createSound({
        autoLoad: true,
        volume: this.state.volume,
        id: 'preroll',
        url: preRoll,
        onfinish: function(){
          self.stream.play();
        }
      });
    }

    createStream(){
      this.stream = soundManager.createSound({
        autoLoad: true,
        volume: this.state.volume,
        stream: true,
        id: 'stream',
        url: mp3_stream
      });
    }

    componentWillMount(){
        var self = this;
        soundManager.setup({
            debugMode: true,
            onready: function(){
              self.createPreroll();
              self.createStream();
            }
        });
    }

    playPause(){

        // check to see if the preroll has played
        if(!this.state.preRollPlay){
          this.preroll.play();
          this.setState({
            playing: true,
            preRollPlay: true
          });
          return;
        }

        if(!this.state.playing){
            this.stream.play();
            this.setState({ playing: true });
        }else{
            this.stream.stop();
            this.setState({ playing: false });
        }
    }

    changeVolume = (e) => {
      this.stream.setVolume(e);
      this.setState({ volume: e });
    }

    render() {
        return (
            <div className="PlayerControls">
              <button
                className="PlayPause"
                onClick={ this.playPause.bind(this) }
                id="play-pause">
                <i className={ !this.state.playing ? "fa fa-play fa-4x" : "fa fa-pause fa-4x" }></i>
              </button>
              <Slider
                value={ this.state.volume }
                onChange={ this.changeVolume.bind(this) }
                orientation="horizontal"
              />
            </div>
        );
    }
}

export default PlayerControls;



// WEBPACK FOOTER //
// ./src/PlayerControls.js